/** Cinsiyet / durum bazlı gradient tanımları */
export const GRADYANLAR = {
  erkek: 'linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #3b82f6 100%)',
  kadin: 'linear-gradient(135deg, #4a0e2e 0%, #be185d 50%, #f472b6 100%)',
  vefat: 'linear-gradient(135deg, #1f2937 0%, #4b5563 50%, #9ca3af 100%)',
  soyagaci: 'linear-gradient(135deg, #052e16 0%, #15803d 50%, #4ade80 100%)',
  varsayilan: 'linear-gradient(135deg, #1e293b 0%, #334155 50%, #64748b 100%)',
} as const;

/** Rozet renkleri */
export const ROZET_RENKLERI = {
  aile: { bg: 'rgba(74,222,128,0.2)', renk: '#bbf7d0' },
  uye: { bg: 'rgba(96,165,250,0.2)', renk: '#bfdbfe' },
  etiket: { bg: 'rgba(255,255,255,0.1)', renk: 'rgba(255,255,255,0.6)' },
} as const;

/** Avatar gradient renkleri (yuz-avatar'da kullanılan) */
export const AVATAR_GRADYANLARI = [
  ['#667eea', '#764ba2'],
  ['#f093fb', '#f5576c'],
  ['#4facfe', '#00f2fe'],
  ['#43e97b', '#38f9d7'],
  ['#fa709a', '#fee140'],
  ['#a18cd1', '#fbc2eb'],
  ['#f6d365', '#fda085'],
  ['#84fab0', '#8fd3f4'],
] as const;

/** İsme göre deterministic gradient index seçer */
export function isimGradyanIndex(isim: string): number {
  let hash = 0;
  for (let i = 0; i < isim.length; i++) {
    hash = ((hash << 5) - hash) + isim.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash) % AVATAR_GRADYANLARI.length;
}

/** Cinsiyet/duruma göre gradient seçer */
export function cinsiyetGradyani(cinsiyet?: string, vefat?: boolean): string {
  if (vefat) return GRADYANLAR.vefat;
  const c = (cinsiyet || '').charAt(0).toUpperCase();
  if (c === 'K' || c === 'F') return GRADYANLAR.kadin;
  if (c === 'E' || c === 'M') return GRADYANLAR.erkek;
  return GRADYANLAR.varsayilan;
}
